import { moduleProviderFactory } from 'core/providers';
import {
	OrderList,
	MarketplaceOrderList,
	OrderDetail,
	MarketplaceOrderDetail,
	ExitScanModeDetail,
	CloseOutDetail,
	FulfillmentOrderHistoryLogList,
	MarketplaceOrderEdit,
	ReturnLabel,
} from 'modules/order/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.order',
				pattern: '/orders',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.order.list',
						pattern: 'fulfillment',
						authorization: 'fulfillmentOrderSection.full',
						component: OrderList,
					},
					{
						name: 'master.app.main.order.list.detail',
						pattern: '/detail/:id',
						component: OrderDetail,
					},
					{
						name: 'master.app.main.order.marketplace.list',
						pattern: 'marketplace',
						authorization: 'marketplaceOrderSection.full',
						component: MarketplaceOrderList,
					},
					{
						name: 'master.app.main.order.marketplace.list.detail',
						pattern: '/marketplace-detail/:id',
						component: MarketplaceOrderDetail,
					},
					{
						name: 'master.app.main.order.exitscanmode.detail',
						pattern: '/exit-scan-detail/:id',
						component: ExitScanModeDetail,
					},
					{
						name: 'master.app.main.order.closeout.detail',
						pattern: '/close-out-detail',
						component: CloseOutDetail,
					},
					{
						name: 'master.app.main.order.list.history-log',
						pattern: '/historylog',
						component: FulfillmentOrderHistoryLogList,
					},
					{
						name: 'master.app.main.order.list.history-log-item',
						pattern: '/history-log/:id',
						component: FulfillmentOrderHistoryLogList,
					},
					{
						name: 'master.app.main.order.list.edit',
						pattern: '/edit/:id',
						component: MarketplaceOrderEdit,
					},
					{
						name: 'master.app.main.order.marketplace.list.add',
						pattern: '/add',
						component: MarketplaceOrderEdit,
					},
					{
						name: 'master.app.main.order.marketplace.list.return-label',
						pattern: '/return-label/:id',
						component: ReturnLabel,
					},
				],
			},
		],
	});
})();
